<template>
  <span class="hidden">{{ start }}</span>
  <div v-if="error" class="text-center text-white mt-10 tracking-wider p-2 bg-[#d20a0a] uppercase">
    {{ error }}
  </div>
  
  <div v-else-if="upcoming" class="text-center text-white mt-10 tracking-wider p-2 bg-[#2e3094] uppercase">
    ESTE EVENTO COMEÇARA EM BREVE

    <Timer
      :initial-hours="timerCount.hours"
      :initial-minutes="timerCount.minutes"
      :initial-seconds="timerCount.seconds"
      @finished="(val) => (start = val)"
    />

  </div>

  <div v-else-if="loading" class="flex justify-center items-center h-96 tracking-wider p-2 bg-[#374151] uppercase">
    <span class="text-white">Carregando transmissão...</span>
  </div>

  <div v-else class="relative w-full aspect-video" :key="start">
    <div
      :key="start"
      ref="playerWrapper"
      class="w-full h-full overflow-hidden rounded-xl shadow-lg relative"
      :class="{ fullscreen: isFullscreen }"
    >
      <iframe
        ref="embedRef"
        :key="iframeKey"
        class="w-full h-full"
        :src="youtubeEmbedUrl"
        frameborder="0"
        allow="autoplay; encrypted-media; picture-in-picture; fullscreen"
        allowfullscreen
        sandbox="allow-same-origin allow-scripts allow-presentation"
        @contextmenu.prevent
      ></iframe>

      <!-- Overlay para bloquear interação -->
      <div
        class="absolute inset-0 z-10 cursor-default"
        @contextmenu.prevent
      ></div>

      <!-- Controles -->
      <div class="absolute bottom-1 left-3 z-30 flex gap-2">
        <button
          class="bg-black/70 text-white px-3 py-2 rounded hover:bg-black/80 tracking-wider flex my-auto mx-auto"
          :disabled="!ready"
          @click="seekBy(-10)"
        >
          <PhSkipBack class="w-5 h-5" />
          10s
        </button>

        <button
          class="bg-black/70 text-white px-3 py-3 rounded hover:bg-black/80 tracking-wider uppercase my-auto mx-auto"
          :disabled="!ready"
          @click="togglePlay"
        >
          <!-- {{ isPlaying ? "Pausar" : "Play" }} -->
          <PhPause v-if="isPlaying" class="w-5 h-5" />
          <PhPlay v-else class="w-5 h-5" />
        </button>

        <button
          class="bg-black/70 text-white px-3 py-2 rounded hover:bg-black/80 tracking-wider flex my-auto mx-auto"
          :disabled="!ready"
          @click="seekBy(10)"
        >
          10s
          <PhSkipForward class="w-5 h-5" />
        </button>
      </div>

      <div class="absolute bottom-1 right-3 z-20 flex gap-2">
        <button
          class="bg-black/60 text-white text-2xl p-2 rounded hover:bg-black/80 tracking-wider uppercase"
          @click="toggleFullscreen"
        >
          <span v-if="!isFullscreen">Tela cheia</span>
          <span v-else>Sair tela cheia</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, watch, onBeforeUnmount, onBeforeUpdate } from 'vue'
import SharedService from '@/shared/services/shared'
import router from '@/router'
import { useRoute } from 'vue-router'
import { dataShared } from '@/shared/store'
import Timer from '../__partials/Timer.vue'
import { onUpdated } from 'vue'
import { PhPause, PhPlay, PhSkipBack, PhSkipForward } from '@phosphor-icons/vue'

const url = process.env.VUE_APP_API_URL
const embedToken = ref(null)
const loading = ref(true)
const error = ref(null)
const upcoming = ref(false)
const timerCount = ref(null)
const isFullscreen = ref(false)
const playerWrapper = ref(null)
const iframeKey = ref(0) // usada para forçar reload do iframe
const iframeStarted = ref(true)
const route = useRoute()
const start = ref(false)

const embedRef = ref(null);
const ready = ref(false);
const isPlaying = ref(false);

const eventId = computed(() => dataShared.getters.getEventLiveId ?? route.params.eventId)

const youtubeEmbedUrl = computed(() => {
  if (!embedToken.value) return ''

  return `${url}embed/${embedToken.value}`
})

async function getEmbedToken () {
  console.log(eventId.value);
  
  await SharedService.getLiveById(eventId.value)
    .then((res) => {
      console.log(res);
      
      if(res.data.status == 'upcoming') {
        upcoming.value = true
        timerCount.value = res.data?.starts_in
      }
      embedToken.value = res.data.embed_token
    })
    .catch((err) => {
      if (err.response?.status === 403) {
        error.value =
          'Você não tem acesso a esta transmissão. Adquira uma licença.'
      } else if (err.response?.status === 404) {
        error.value = 'Este evento não esta mais disponível!'
      } else if (err.response?.status === 401) {
        router.push('/auth')
      } else {
        error.value = 'Erro ao carregar o vídeo. Tente novamente mais tarde.'
      }
    })

  loading.value = false
}

watch(
  () => youtubeEmbedUrl.value, 
  () => {
    ready.value = false;
    isPlaying.value = false;
  },
  { immediate: true }
);

watch(
  start,
  (newVal) => {
    console.log(newVal, 'transmitir');
    getEmbedToken();
    forcePlay()
  },
  { immediate: true }
)

function toggleFullscreen () {
  const el = playerWrapper.value
  if (!document.fullscreenElement) {
    el.requestFullscreen().then(() => {
      isFullscreen.value = true
    })
  } else {
    document.exitFullscreen().then(() => {
      isFullscreen.value = false
    })
  }
}

function forcePlay () {
  upcoming.value = false
  iframeStarted.value = true
  iframeKey.value++ // força re-render do iframe
}

function postToEmbed(msg) {
  const w = embedRef.value?.contentWindow;
  if (!w) return;

  let targetOrigin = '*';
  try { targetOrigin = new URL(youtubeEmbedUrl.value).origin; } catch {}
  w.postMessage(msg, targetOrigin);
}

function play()       { postToEmbed({ type: 'PLAY'  }); isPlaying.value = true; }
function pause()      { postToEmbed({ type: 'PAUSE' }); isPlaying.value = false; }
function togglePlay() { isPlaying.value ? pause() : play(); }
function seekBy(sec)  { postToEmbed({ type: 'SEEK_BY', delta: sec }); }

function onMessage(e) {
  const data = e.data || {};
  if (data.type === 'READY') ready.value = true;
  if (data.type === 'STATE') {
    // 1 = playing, 2 = paused (YouTube codes)
    isPlaying.value = data.state === 1;
  }
}

onBeforeUnmount(() => window.removeEventListener('message', onMessage));

onMounted(() => {
  window.addEventListener('message', onMessage)

  setTimeout(() => {
    const iframe = document.querySelector('iframe')
    if (!iframe?.contentWindow) {
      iframeStarted.value = false
    }
  }, 3000)

  getEmbedToken()
  
})

</script>

<style scoped>
iframe {
  pointer-events: auto;
  user-select: none;
}
</style>
